<template>
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="32" fill="#6F4FCC" fill-opacity="0.2"/>
        <circle cx="32.0018" cy="32.0018" r="23.4667" fill="url(#paint0_linear_7078_106729)"/>
        <path d="M42.6651 24.5352L28.1889 39.4685L22.3984 33.4952" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        <defs>
            <linearGradient id="paint0_linear_7078_106729" x1="32.0018" y1="8.53516" x2="32.0018" y2="55.4685" gradientUnits="userSpaceOnUse">
                <stop stop-color="#6342C5"/>
                <stop offset="1" stop-color="#8563E9"/>
            </linearGradient>
        </defs>
    </svg>
</template>
